import { FC } from 'react';
import {
  Skeleton as CKSkeleton,
  SkeletonCircle,
  SkeletonText,
  SkeletonProps as CKSkeletonProps,
  SkeletonTextProps,
  Box,
} from '@chakra-ui/react';

export type SkeletonProps =
  | (Omit<CKSkeletonProps, 'variant'> & { variant?: 'rect' | 'circle' })
  | (Omit<SkeletonTextProps, 'variant'> & { variant?: 'text' });

export const Skeleton: FC<SkeletonProps> = ({ variant, isLoaded, ...props }) => {
  const sharedProps: CKSkeletonProps = {
    speed: 1.2,
    // Set fixed default dimensions
    height: '3rem',
    width: '10rem',
  };

  if (isLoaded) {
    return (
      <Box width="100%" minWidth={0}>
        {props.children}
      </Box>
    );
  }

  switch (variant) {
    case 'text': {
      const textProps = props as SkeletonTextProps;
      // Default to full width so modal / grid content is not stuck at 10rem while loading.
      const textWidth = textProps.width ?? '100%';

      return (
        <SkeletonText
          {...sharedProps}
          {...textProps}
          width={textWidth}
          height={`${textProps.noOfLines || 3}rem`}
        />
      );
    }
    case 'circle':
      return <SkeletonCircle {...sharedProps} {...props} />;
    default:
      return <CKSkeleton {...sharedProps} {...props} />;
  }
};
